module.exports = __webpack_public_path__ + "img/jazza.36aecc90.jpg";